import { NavigationItem } from '@10d/tend-ui-header';

import { Submenu } from '../types';
import { DEV, PROD, STAGE } from 'consts';

export const filterEnvironment = (menuItems: Submenu<NavigationItem>[], version: IVesion) => {
  const { stand } = version;

  return menuItems.filter(item => {
    if (Array.isArray(item.environment)) {
      return item.environment.includes(stand);
    } else if (typeof item.environment === 'string') {
      return item.environment === stand;
    } else {
      return false;
    }
  });
};

interface IVesion {
  stand: typeof DEV | typeof PROD | typeof STAGE;
}
